import { useEffect, useRef } from "react";

/**
 * Custom hook to handle window resize events.
 *
 * @param {Object} params - Parameters for the hook.
 * @param {Function} params.callback - Callback function to be called on window resize.
 * @param {number} [params.endDelay=300] - Delay in milliseconds to call the callback after resizing ends.
 * @return {void}
 */
export const useWindowResize = ({ callback, endDelay = 300 }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      callback();

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(() => {
        callback();
      }, endDelay);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [callback, endDelay]);
};
